<template>
  <button
    class="btn"
    type="button"
    @click="openQuiz"
  >
    <slot>Take the Quiz</slot>
  </button>
</template>

<script>
import QuizDiscover from '@/components/QuizDiscover.vue';

export default {
  name: 'QuizDiscoverButton',

  setup() {
    const modal = useModal();
    return { modal };
  },

  methods: {
    openQuiz() {
      this.modal(QuizDiscover, this);
    }
  }
};
</script>
